var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_3271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4523 0C5.59453 0 0 5.59453 0 12.4523V30.4477C0 37.3055 5.59453 42.9 12.4523 42.9H30.4477C37.3055 42.9 42.9 37.3055 42.9 30.4477V12.4523C42.9 5.59453 37.3055 0 30.4477 0H12.4523ZM12.4523 3.3H30.4477C35.5201 3.3 39.6 7.37344 39.6 12.4523V30.4477C39.6 35.5201 35.5266 39.6 30.4477 39.6H12.4523C7.37988 39.6 3.3 35.5266 3.3 30.4477V12.4523C3.3 7.37988 7.37344 3.3 12.4523 3.3ZM33.825 6.6C32.4586 6.6 31.35 7.70859 31.35 9.075C31.35 10.4414 32.4586 11.55 33.825 11.55C35.1914 11.55 36.3 10.4414 36.3 9.075C36.3 7.70859 35.1914 6.6 33.825 6.6ZM21.45 9.9C15.0885 9.9 9.9 15.0885 9.9 21.45C9.9 27.8115 15.0885 33 21.45 33C27.8115 33 33 27.8115 33 21.45C33 15.0885 27.8115 9.9 21.45 9.9ZM21.45 13.2C26.0262 13.2 29.7 16.8738 29.7 21.45C29.7 26.0262 26.0262 29.7 21.45 29.7C16.8738 29.7 13.2 26.0262 13.2 21.45C13.2 16.8738 16.8738 13.2 21.45 13.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_3271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9,
    height: 42.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f7f9a2b48b5cfab289d8b5926f0ff1cf.svg";
export { ForwardRef as ReactComponent };